import { useLocation, useNavigate } from 'react-router-dom';
import { Tabs } from 'antd';
import { useTranslation } from 'react-i18next';

const FILES_TABS = [
  { key: '/files', labelKey: 'file.list_title' },
  { key: '/files/shares', labelKey: 'file.shares_title' },
];

export default function FilesNav() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const activeKey = location.pathname.startsWith('/files/shares')
    ? '/files/shares'
    : '/files';

  return (
    <Tabs
      activeKey={activeKey}
      onChange={(key) => navigate(key)}
      items={FILES_TABS.map((tab) => ({
        key: tab.key,
        label: t(tab.labelKey),
      }))}
      style={{ marginBottom: 16 }}
    />
  );
}
